import React from "react";
import { useLocation } from "react-router-dom";
import AuthScreen from "../components/Auth/AuthScreen";

const Login = () => {
  const location = useLocation();
  const modeFromState = location.state?.mode;
  const initialMode = modeFromState === "signup" ? "signup" : "signin";

  return <AuthScreen initialMode={initialMode} />;
};

export default Login;
